import './Footer.css'

const Footer = () => {
  return <div className='app__footer'>
    <a>&lt; Designed and Built by AJ /&gt;</a>
  </div>;
};

export default Footer;
